import Banner_image from "../../assets/Section-background.png";
import { NavLink } from 'react-router-dom'


export default function Dedicated() {
    return (
        <section className="section pricing-page" id="Prcing" style={{ background: `url(${Banner_image})`, }}>
            <div className='container'>
                <div className="banner-wrapper">
                    <div className="pricing-section-wrap">
                        <h1 className='title'>Choose the Right Plan For Your Business</h1>
                        <p className='content'>Explore our plans and find the perfect fit for your Shopify development needs. Get expert support, custom design, development, and marketing services to build and grow your online store.</p>
                        <NavLink className="btn btn-primary " to="/contact">LET'S CONNECT</NavLink>
                    </div>
                </div>
            </div>
        </section>
    )
}
